import Phaser from "phaser"
import { getTopPlayers } from "../../services/Request"
export default class Leaderboard extends Phaser.Scene {

    preload() {
        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));

        this.load.image("leaderboard-header", require('./assets/Leaderboard.png'));
        this.load.image("leaderboard-text", require('./assets/Leaderboard_Txt.png'));
        this.load.image("leaderboard-pos01", require('./assets/Pos_1.png'));
        this.load.image("leaderboard-pos02", require('./assets/Pos_2.png'));
        this.load.image("leaderboard-pos03", require('./assets/Pos_3.png'));
        this.load.image("leaderboard-pos04", require('./assets/Pos_4.png'));
        this.load.image("leaderboard-pos05", require('./assets/Pos_5.png'));
        this.load.image("leaderboard-pos06", require('./assets/Pos_6.png'));
        this.load.image("leaderboard-pos07", require('./assets/Pos_7.png'));
        this.load.image("leaderboard-pos08", require('./assets/Pos_8.png'));

        this.load.image("leaderboard-backBtn-white-border", require('../../assets/back-button-white.png'));
    }
    create() {

        this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
        this.soundConfig();
        this.canvasWidth = this.game.config.width;
        this.canvasHeight = this.game.config.height;



        var components = [];
        components.push(this.add.rectangle(0, 0, this.canvasWidth, this.canvasHeight * 2, 0xffffff).setOrigin(0, 0))
        components.push(this.add.image(0, 0, "leaderboard-header").setOrigin(0, 0))
        components.push(this.add.image(this.canvasWidth / 2, 200, "leaderboard-text"))

        getTopPlayers((ranking) => {
            var basePoxY = 1200;
            for (var i = 0; i < 8; i++) {
                let bgPosition = this.add.image(this.canvasWidth / 2, basePoxY, "leaderboard-pos0" + (i + 1));
                components.push(bgPosition);

                if (ranking[i]) {
                    let username = this.add.text(400, basePoxY - 55, ranking[i].user_name.charAt(0).toUpperCase() + ranking[i].user_name.slice(1), {
                        color: '#DC7438',
                        boundsAlignH: "center", boundsAlignV: "middle",
                        font: '400 68px Rockridge'
                    })
                    components.push(username);

                    var date = new Date(ranking[i].created_at);
                    var formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

                    let score = this.add.text(400, basePoxY + 20, "Score: " + ranking[i].score + " Points | " + formattedDate, {
                        color: '#DC7438',
                        boundsAlignH: "center", boundsAlignV: "middle",
                        font: '300 35px Rockridge'
                    })
                    components.push(score);
                } else {
                    let username = this.add.text(400, basePoxY - 33, "", {
                        color: '#898989',
                        boundsAlignH: "center", boundsAlignV: "middle",
                        font: '300 65px Rockridge'
                    })
                    components.push(username);
                }
                basePoxY += 175
            }

            var leaderboardContainer = this.add.container(0, 0, components);
            leaderboardContainer.setSize(5000, 10000);
            leaderboardContainer.setInteractive();
            this.input.setDraggable(leaderboardContainer);


            this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
                if (dragY < 0 && dragY > -850) {
                    gameObject.y = dragY;
                }
            });

            this.backBtn = this.add.image(100, 100, "leaderboard-backBtn-white-border").setScale(0.2);
            this.backBtn.setInteractive();
            this.backBtn.on('pointerdown', (pointer) => {
                this.clickSound.play();
                this.scene.start('Introduction');
            });
        });

    }

    soundConfig(){
        this.clickSound.mute = !this.game.config.soundSetting;
    }


    update() {

    }

}